var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 193 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: "current"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.8039,
    cy: 96.1637,
    rx: 80.5803,
    ry: 80.5767,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 51.7261L122.153 89.5981",
    strokeOpacity: "current",
    stroke: "#E4E4E4",
    strokeWidth: 5.35272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8882 83.5552L70.9505 96.1667",
    strokeOpacity: "current",
    stroke: "#E4E4E4",
    strokeWidth: 5.35272,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.497 96.1757C191.497 148.464 149.108 190.851 96.8172 190.851C44.5268 190.851 2.13721 148.464 2.13721 96.1757C2.13721 43.8878 44.5268 1.5 96.8172 1.5C149.108 1.5 191.497 43.8878 191.497 96.1757Z",
    stroke: "#EDEDED",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.093 43.4528C95.2769 42.2567 96.9931 42.2365 97.2051 43.428L107.193 99.5658C107.555 101.601 108.307 103.547 109.407 105.298L129.736 137.644C130.358 138.633 129.173 139.76 128.216 139.091L105.28 123.043C99.7523 119.175 92.396 119.175 86.868 123.043L64.2709 138.854C63.3004 139.533 62.1088 138.366 62.7672 137.382L84.0099 105.61C85.3145 103.659 86.1755 101.445 86.5323 99.1253L95.093 43.4528Z",
    fill: "#E4E4E4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierBg1);
export default __webpack_public_path__ + "static/media/tier-bg-1.54c7bc234c6e35b00dbb6e18f4c4b939.svg";
export { ForwardRef as ReactComponent };